import React, { Component, ReactNode } from "react";

// @ts-ignore
import cn from "classnames";
import WorkflowActions from "./WorkflowActions";
import {
  workflowStepCN,
  workflowStepSuccessfulCN,
  workflowStepIdLabelCN,
  workflowStepContentCN,
  workflowStepContentTitleCN,
} from "./styles";

import type { WorkflowStep } from "../../../../redux/modules/workflow/reducer";
import RollbackButton from "./RollbackButton";

interface WorkflowStepSuccessfulProps {
  step: WorkflowStep;
  isRollbackAvailable: boolean;
  onRollback: () => void;
  children?: ReactNode;
}

export default class WorkflowStepSuccessful extends Component<WorkflowStepSuccessfulProps> {
  render() {
    const { title, id } = this.props.step;
    const { isRollbackAvailable } = this.props;

    return (
      <div
        id={`workflow-step-${id}`}
        className={cn(workflowStepCN, workflowStepSuccessfulCN)}
      >
        <div className={workflowStepIdLabelCN}>
          <img src="ic-workflow-status-successful.svg" />
        </div>
        <div className={workflowStepContentCN}>
          {isRollbackAvailable ? (
            <RollbackButton onClick={() => this.props.onRollback()} />
          ) : null}
          <div className={workflowStepContentTitleCN}>{title}</div>
          <WorkflowActions
            disabled={true}
            collapsed={true}
            step={this.props.step}

            // fixme
            onSubmit={() => { /* noop */}}
          />
        </div>
      </div>
    );
  }
}
